import React, { PropsWithChildren } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./MenuItem.module.css";

interface Props {
  onClick: () => void;
  className?: string;
}

const MenuItem: React.FC<PropsWithChildren<Props>> = ({
  children,
  onClick,
  className,
}) => (
  <button
    type="button"
    className={toClassName(styles.item, className)}
    onClick={onClick}
  >
    {children}
  </button>
);

export default MenuItem;
